/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { darken } from '@mui/material';
import { colors } from '../constants';
const styleOverrides = {
  root: ({
    ownerState: {
      color,
      variant
    },
    theme
  }) => ({
    '&:hover,&:focus': {
      fontWeight: 'bold',
      ...(typeof color === 'string' && color.startsWith('text') && {
        color: darken(
        // @ts-expect-error -- needed
        colors.text[color.replace('text', '').toLowerCase()] || colors.text.primary, 0.2)
      }),
      ...(typeof color === 'string' && !color.startsWith('text') && {
        // @ts-expect-error -- needed
        color: theme.palette[color]?.dark || color
      })
    },
    ...(variant === 'button' && {
      textUnderlineOffset: '.25em',
      textDecorationThickness: '2px'
    })
  }),
  underlineAlways: {
    textDecorationColor: 'currentcolor'
  }
};
const defaultProps = {
  underline: 'always',
  variant: 'body1',
  color: 'textPrimary'
};
export default {
  styleOverrides,
  defaultProps
};